import React, { SyntheticEvent } from 'react';

import { __t, applyTranslations } from 'utils/language';

import ContentPerformanceFilter from './filter/ContentPerformanceFilter';
import ContentPerformanceViewer from './viewer/ContentPerformanceViewer';

import './content-performance-filters.scss';

applyTranslations(require('../content-performance.i18n.json'));

import type { MixedSelectDropdownItem } from 'types';
import type {
  ContentPerformanceDataType,
  ContentPerformanceDropdownOptions
} from 'modules/reporting/components/content-performance/types';

type Props = {
  selectedOptions: ContentPerformanceDropdownOptions,
  dataTypesToShow: Array<ContentPerformanceDataType>,
  view: string,
  onSetSelectedOptions: (a: Array<MixedSelectDropdownItem>) => void,
  onSetView: (event: SyntheticEvent<HTMLElement>) => void
};

const MSG_KEY = 'content_performance';

const ContentPerformanceFilters = ({
  selectedOptions,
  dataTypesToShow,
  view,
  onSetSelectedOptions,
  onSetView
}: Props): JSX.Element => (
  <div className="content-performance-filters">
    <ContentPerformanceFilter
      label={__t(`${MSG_KEY}.labels.select_kpi`)}
      type="kpi"
      selectedOptionKpi={selectedOptions.kpi}
      selectedOptionFormat={selectedOptions.format}
      dataTypesToShow={dataTypesToShow}
      showPopover
      onSetSelectedOptions={onSetSelectedOptions}
    />
    {
      dataTypesToShow.length > 1 && (
        <ContentPerformanceFilter
          label={__t(`${MSG_KEY}.labels.select_format`)}
          type="format"
          selectedOptionKpi={selectedOptions.kpi}
          selectedOptionFormat={selectedOptions.format}
          dataTypesToShow={dataTypesToShow}
          onSetSelectedOptions={onSetSelectedOptions}
        />
      )
    }
    <ContentPerformanceViewer
      view={view}
      onSetView={onSetView}
    />
  </div>
);

export default ContentPerformanceFilters;
